// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.currency-rates-page__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}
@media (max-width: 1300px) {
  .currency-rates-page__grid {
    grid-template-columns: 1fr;
  }
}
.currency-rates-page__column {
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0;
}
.currency-rates-page__top-action {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  flex-wrap: wrap;
}
.currency-rates-page__card {
  height: -moz-fit-content;
  height: fit-content;
}
.currency-rates-page__currency-row, .currency-rates-page__percent-row {
  padding: 14px;
  border-radius: 12px;
  background: #1b1b1b;
}
.currency-rates-page__currency-row {
  display: grid;
  grid-template-columns: 84px minmax(130px, 1fr) 140px 200px auto;
  gap: 12px;
  align-items: center;
}
@media (max-width: 1600px) {
  .currency-rates-page__currency-row {
    grid-template-columns: 84px minmax(130px, 1fr) 130px 200px;
  }
}
@media (max-width: 1600px) {
  .currency-rates-page__currency-row .currency-rates-page__row-actions {
    grid-column: 1/-1;
    justify-content: flex-end;
  }
}
@media (max-width: 900px) {
  .currency-rates-page__currency-row {
    grid-template-columns: 84px minmax(0, 1fr);
  }
}
@media (max-width: 900px) {
  .currency-rates-page__currency-row .currency-rates-page__input:nth-child(2),
  .currency-rates-page__currency-row .currency-rates-page__input:nth-child(3),
  .currency-rates-page__currency-row .currency-rates-page__input:nth-child(4) {
    grid-column: 2;
  }
  .currency-rates-page__currency-row .currency-rates-page__row-actions {
    grid-column: 1/-1;
    justify-content: flex-start;
  }
}
@media (max-width: 640px) {
  .currency-rates-page__currency-row {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 640px) {
  .currency-rates-page__currency-row .currency-rates-page__input:nth-child(2),
  .currency-rates-page__currency-row .currency-rates-page__input:nth-child(3),
  .currency-rates-page__currency-row .currency-rates-page__input:nth-child(4) {
    grid-column: auto;
  }
  .currency-rates-page__currency-row .currency-rates-page__icon {
    width: 100%;
    max-width: 84px;
  }
}
.currency-rates-page__percent-row {
  display: grid;
  grid-template-columns: minmax(180px, 1fr) 200px auto;
  gap: 12px;
  align-items: center;
}
@media (max-width: 1200px) {
  .currency-rates-page__percent-row {
    grid-template-columns: 1fr;
  }
}
.currency-rates-page__icon {
  position: relative;
  width: 84px;
  min-width: 84px;
  height: 84px;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  display: block;
  background: #252525;
  border: 1px solid #333;
  transition: border-color 0.2s ease, transform 0.2s ease;
}
.currency-rates-page__icon input {
  display: none;
}
.currency-rates-page__icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.currency-rates-page__icon:hover {
  border-color: #4b79ff;
}
.currency-rates-page__icon-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9f9f9f;
  font-size: 12px;
  text-align: center;
  padding: 8px;
}
.currency-rates-page__icon-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.62);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;
  font-size: 12px;
  padding: 8px;
  text-align: center;
}
.currency-rates-page__icon:hover .currency-rates-page__icon-overlay {
  opacity: 1;
}
.currency-rates-page__input {
  width: 100%;
  margin-bottom: 0;
  min-width: 0;
}
.currency-rates-page__row-actions {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
}
.currency-rates-page__error {
  color: #DB3522;
  font-size: 12px;
  margin-bottom: 20px;
}
.currency-rates-page__empty {
  color: #BBB7B7;
}
.currency-rates-page .main-admin__card-content {
  gap: 12px;
}
.currency-rates-page .rect-btn {
  min-width: 120px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Admin/CurrencyRatesPage.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAAJ;AAEI;EALF;IAMI,0BAAA;EACJ;AACF;AAEE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;EACA,eAAA;AADJ;AAIE;EACE,wBAAA;EAAA,mBAAA;AAFJ;AAKE;EAEE,aAAA;EACA,mBAAA;EACA,mBAAA;AAJJ;AAOE;EACE,aAAA;EACA,+DAAA;EACA,SAAA;EACA,mBAAA;AALJ;AAOI;EANF;IAOI,0DAAA;EAJJ;AACF;AAMI;EACE;IACE,iBAAA;IACA,yBAAA;EAJN;AACF;AAOI;EAjBF;IAkBI,0CAAA;EAJJ;AACF;AAMI;EACE;;;IAGE,cAAA;EAJN;EAOI;IACE,iBAAA;IACA,2BAAA;EALN;AACF;AAQI;EAlCF;IAmCI,0BAAA;EALJ;AACF;AAOI;EACE;;;IAGE,iBAAA;EALN;EAQI;IACE,WAAA;IACA,eAAA;EANN;AACF;AAUE;EACE,aAAA;EACA,oDAAA;EACA,SAAA;EACA,mBAAA;AARJ;AAUI;EANF;IAOI,0BAAA;EAPJ;AACF;AAUE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,uDAAA;AARJ;AAUI;EACE,aAAA;AARN;AAWI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AATN;AAYI;EACE,qBAAA;AAVN;AAcE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AAZJ;AAeE;EACE,kBAAA;EACA,QAAA;EACA,+BAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,6BAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAbJ;AAiBE;EACE,UAAA;AAfJ;AAkBE;EACE,WAAA;EACA,gBAAA;EACA,YAAA;AAhBJ;AAmBE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAjBJ;AAoBE;EACE,cAAA;EACA,eAAA;EACA,mBAAA;AAlBJ;AAqBE;EACE,cAAA;AAnBJ;AAsBE;EACE,SAAA;AApBJ;AAuBE;EACE,gBAAA;AArBJ","sourcesContent":[".currency-rates-page {\r\n  &__grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    gap: 20px;\r\n\r\n    @media (max-width: 1300px) {\r\n      grid-template-columns: 1fr;\r\n    }\r\n  }\r\n\r\n  &__column {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    min-width: 0;\r\n  }\r\n\r\n  &__top-action {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    gap: 12px;\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  &__card {\r\n    height: fit-content;\r\n  }\r\n\r\n  &__currency-row,\r\n  &__percent-row {\r\n    padding: 14px;\r\n    border-radius: 12px;\r\n    background: #1b1b1b;\r\n  }\r\n\r\n  &__currency-row {\r\n    display: grid;\r\n    grid-template-columns: 84px minmax(130px, 1fr) 140px 200px auto;\r\n    gap: 12px;\r\n    align-items: center;\r\n\r\n    @media (max-width: 1600px) {\r\n      grid-template-columns: 84px minmax(130px, 1fr) 130px 200px;\r\n    }\r\n\r\n    @media (max-width: 1600px) {\r\n      .currency-rates-page__row-actions {\r\n        grid-column: 1 / -1;\r\n        justify-content: flex-end;\r\n      }\r\n    }\r\n\r\n    @media (max-width: 900px) {\r\n      grid-template-columns: 84px minmax(0, 1fr);\r\n    }\r\n\r\n    @media (max-width: 900px) {\r\n      .currency-rates-page__input:nth-child(2),\r\n      .currency-rates-page__input:nth-child(3),\r\n      .currency-rates-page__input:nth-child(4) {\r\n        grid-column: 2;\r\n      }\r\n\r\n      .currency-rates-page__row-actions {\r\n        grid-column: 1 / -1;\r\n        justify-content: flex-start;\r\n      }\r\n    }\r\n\r\n    @media (max-width: 640px) {\r\n      grid-template-columns: 1fr;\r\n    }\r\n\r\n    @media (max-width: 640px) {\r\n      .currency-rates-page__input:nth-child(2),\r\n      .currency-rates-page__input:nth-child(3),\r\n      .currency-rates-page__input:nth-child(4) {\r\n        grid-column: auto;\r\n      }\r\n\r\n      .currency-rates-page__icon {\r\n        width: 100%;\r\n        max-width: 84px;\r\n      }\r\n    }\r\n  }\r\n\r\n  &__percent-row {\r\n    display: grid;\r\n    grid-template-columns: minmax(180px, 1fr) 200px auto;\r\n    gap: 12px;\r\n    align-items: center;\r\n\r\n    @media (max-width: 1200px) {\r\n      grid-template-columns: 1fr;\r\n    }\r\n  }\r\n\r\n  &__icon {\r\n    position: relative;\r\n    width: 84px;\r\n    min-width: 84px;\r\n    height: 84px;\r\n    border-radius: 12px;\r\n    overflow: hidden;\r\n    cursor: pointer;\r\n    display: block;\r\n    background: #252525;\r\n    border: 1px solid #333;\r\n    transition: border-color 0.2s ease, transform 0.2s ease;\r\n\r\n    input {\r\n      display: none;\r\n    }\r\n\r\n    img {\r\n      width: 100%;\r\n      height: 100%;\r\n      object-fit: cover;\r\n      display: block;\r\n    }\r\n\r\n    &:hover {\r\n      border-color: #4b79ff;\r\n    }\r\n  }\r\n\r\n  &__icon-placeholder {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: #9f9f9f;\r\n    font-size: 12px;\r\n    text-align: center;\r\n    padding: 8px;\r\n  }\r\n\r\n  &__icon-overlay {\r\n    position: absolute;\r\n    inset: 0;\r\n    background: rgba(0, 0, 0, 0.62);\r\n    color: #fff;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    opacity: 0;\r\n    transition: opacity 0.2s ease;\r\n    font-size: 12px;\r\n    padding: 8px;\r\n    text-align: center;\r\n\r\n  }\r\n\r\n  &__icon:hover &__icon-overlay {\r\n    opacity: 1;\r\n  }\r\n\r\n  &__input {\r\n    width: 100%;\r\n    margin-bottom: 0;\r\n    min-width: 0;\r\n  }\r\n\r\n  &__row-actions {\r\n    display: flex;\r\n    gap: 10px;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  &__error {\r\n    color: #DB3522;\r\n    font-size: 12px;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  &__empty {\r\n    color: #BBB7B7;\r\n  }\r\n\r\n  .main-admin__card-content {\r\n    gap: 12px;\r\n  }\r\n\r\n  .rect-btn {\r\n    min-width: 120px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
